<template>
  <Form
    ref="creditCardForm"
    :model="model" 
    :rules="rules"
    :label-width="80"
    label-position="left"
    class="credit-form form-flex middle"
  >
    <FormItem 
      label="信用卡號"
      prop="cardNo"
    >
      <Row      
        type="flex" 
        justify="start" 
        class="code-row-bg"
        :gutter="8"
      > 
        <Col
          v-for="key in Object.keys(model.cardNo)"
          :key="key"
          :lg="6"
          :md="5"
          :xs="6"      
        >
          <Input
            :ref="key"
            v-model="model.cardNo[key]"
            size="large"
            placeholder="xxxx"
            :maxlength="4"
            @on-change="handleFocus(key)"
          />
        </Col>
      </Row>
    </FormItem>
    <FormItem
      label="有效年月"
      prop="deadlineAndCCV"
    >
      <Row 
        type="flex"
        justify="start"
        class="code-row-bg"
        :gutter="8"
      >
        <Col
          v-for="(key, index) in ['yy', 'mm', 'span', 'ccv']"
          :key="`key-${index}`"
          :lg="6"
          :md="5"
          :xs="6"
          :class="key === 'span' ? 'text-center' : null"
        >
          <VueSelect
            v-if="key === 'yy' || key === 'mm'"
            v-model="model.deadlineAndCCV[key]"
            class="base-vue-select hide-clear"
            transition="none"
            max-height="180px"
            :searchable="false"
            :options="options[key]"
            :placeholder="key"
          />
          <span
            v-if="key === 'span'"
            v-text="'背面末三碼'"
            class="fz-tiny"
          />
          <Input
            v-if="key === 'ccv'"
            v-model="model.deadlineAndCCV[key]"
            type="text"             
            size="large"
            placeholder="CCV"
            :maxlength="3"
          />
        </Col>
      </Row>
    </FormItem>
  </Form>
</template>

<script>
  import { Row, Col, Form, FormItem, Input } from 'iview';
  import VueSelect from 'vue-select';
  import getYear from 'date-fns/get_year';
  import { rules, model } from '@/utils/asyncValidator/creditCardForm';

  export default {
    components: {
      Row,
      Col,
      Form,
      FormItem,
      Input,
      VueSelect
    },
    data() {
      return {
        thisYear: getYear(new Date()),
        model: { 
          cardNo: { ...model.cardNo },
          deadlineAndCCV: { ...model.deadlineAndCCV }
        },
        rules,
      };
    },
    computed: {
      options() {
        const { thisYear } = this;
        const yy = Array.from({ length: 10 }, (x, i) => (thisYear + i).toString().slice(2));  
        const mm = Array.from({ length: 12 }, (x, i) => {
          const value = `${i + 1}`;
          return value.length < 2 ? `0${value}` : value;
        });
        return { yy, mm };
      }
    },
    methods: {
      handleFocus(key) {
        const { length } = this.model.cardNo[key];
        const totalLength = Object.values(this.model.cardNo)
          .reduce((acc, str) => acc + str.length, 0);
        if (length !== 4) return;
        if (totalLength === 16) return this.$refs[key][0].blur();
        switch (key) {
          case 'block1':
            return this.$refs.block2[0].focus();
          case 'block2':
            return this.$refs.block3[0].focus();
          case 'block3':
            return this.$refs.block4[0].focus();
          default:
            return this.$refs[key][0].blur();
        }
      },
      async getPayload() {
        const { block1, block2, block3, block4 } = this.model.cardNo;
        const { deadlineAndCCV } = this.model;
        const cardNo = `${block1}${block2}${block3}${block4}`;
        const isValid = await this.validate();
        if (!isValid) return;
        return { cardNo, ...deadlineAndCCV };
      },
      validate() {
        return this.$refs.creditCardForm.validate(v => v);
      }
    }
  };
</script>